import Asset from "@components/CustomTypography/Asset/Asset"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import ButtonComponent from "@components/Theme/Button/Button"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useRef} from "react"
import {CSSTransition, TransitionGroup} from "react-transition-group"

import styles from "./ContentAsset.module.scss"
import {ContentAssetExpandedContentType} from "./ContentAssetExpandedTypes"

const ContentAssetExpandedContent = (
	props: ContentAssetExpandedContentType,
): JSX.Element => {
	// Reference for animation of expanded list item
	const nodeRef = useRef(null)

	return (
		<>
			{/* Title on the List Items */}
			{/* <Typography content={props.data?.sectionTitle} variant={Variant.Title} fontWeight={200}/> */}
			<ul className={styles.list}>
				{props.data?.mainContent?.map(
					(element: AdvancedSideAssetMainContent, index: number) => {
						return (
							<li
								key={`list-item-${element.title}-${index}`}
								className={styles.list__item}
							>
								<>
									{/* Button with title for expanding of List Item */}
									<ButtonComponent
										buttonType={"expandedSecondary"}
										className={styles.button}
										expandActive={props.id === index}
										expandUnactive={props.id !== index}
										size={"default"}
										onClick={() => {
											props.handleClick(index)
										}}
									>
										<Typography
											as={"h3"}
											className={styles.listItem}
											content={element.title}
											id={String(index)}
											size={Size.M}
											variant={Variant.Title}
											stripHtml
											noPadding={
												props.id !== index ||
												!element.subtitle
											}
										/>
										<Typography
											className={
												props.id === index
													? styles.visibleSubtitle
													: styles.hiddenSubtitlte
											}
											content={element.subtitle}
											as={"p"}
											variant={Variant.Description}
										/>
									</ButtonComponent>
									{/* Animated List Item content body */}
									<TransitionGroup>
										<CSSTransition
											classNames={{
												enter: styles.listEnter,
												enterActive:
													styles.listEnterActive,
												exit: styles.listExit,
												exitActive:
													styles.listExitActive,
											}}
											in={props.id === index}
											nodeRef={nodeRef}
											timeout={500}
										>
											<div
												ref={nodeRef}
												className={
													props.id === index
														? styles.visible
														: styles.hidden
												}
											>
												<Asset
													data={{
														...element?.preview,
														imageClassName:
															styles.imageClassNameMobile,

														alt:
															element?.title ??
															element?.preview
																?.alt,
													}}
													type={
														element?.preview?.type
															? element?.preview
																	?.type
															: "string"
													}
												/>
												<Typography
													className={
														styles.contentTypographt
													}
													content={element.content}
													variant={
														Variant.Description
													}
												/>
												{/* Defining the right Button Type, Link or Popup Button */}
												{element.buttons != null && (
													<>
														<Separator size={16} />
														<ButtonContainer>
															<ButtonSwitcher
																buttonsList={
																	element
																}
															/>
														</ButtonContainer>
													</>
												)}
											</div>
										</CSSTransition>
									</TransitionGroup>
								</>
							</li>
						)
					},
				)}
			</ul>
		</>
	)
}

export default ContentAssetExpandedContent
